var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"width":"0px","height":"0px","position":"relative","z-index":"0"}},[_c('router-link',{staticClass:"rowlink",staticStyle:{"display":"block","position":"relative","width":"0px","height":"0px","z-index":"0"},attrs:{"to":_vm.to}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }